import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { UIIcon } from '../icon/icon.enum';

import { UISnackbarType } from './snackbar-type.enum';
import { SnackbarMap, SnackbarViewModel } from './snackbar-view-model.type';
import { UISnackbar } from './snackbar.interface';

@Component({
  selector: 'ui-snackbar',
  templateUrl: './snackbar.component.html',
  styleUrls: ['./snackbar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class UISnackbarComponent {
  data = inject<UISnackbar>(MAT_SNACK_BAR_DATA);

  snackBarRef = inject(MatSnackBarRef);
  snackbarViewModel: SnackbarMap = {
    [UISnackbarType.Positive]: { icon: UIIcon.CheckSingle, color: 'green' },
    [UISnackbarType.Negative]: { icon: UIIcon.CircleWarning, color: 'red', actionText: 'DISMISS' },
    [UISnackbarType.Warning]: { icon: UIIcon.Warning, color: 'orange', actionText: 'OK' },
    [UISnackbarType.Neutral]: {},
  };

  get snackbar(): SnackbarViewModel {
    return this.snackbarViewModel[this.data.type];
  }
}
